module.exports = __webpack_public_path__ + "img/francine.6f7477b2.png";